import React from "react";
import { PreferencesContext } from "./PreferencesContext";

interface Props {
  children: React.ReactNode;
}

const HAS_ACCEPTED_DATA_KEY = "has_accepted_data";
const FIRST_ANALYTICS_ENABLED_DATE_KEY = "analytics_first_enabled_date";

export const PROFILE_ID_KEY = "profile_id";
export const TEMPORARY_SPEAKING_RATE_KEY = "temporary_speaking_rate";
export const AB_IDENTIFIER_KEY = "ab_identifier"
export const QUERY_PARAM_PREFIX = "qp_";

export const PreferencesProvider = (props: Props) => {
  const [hasAcceptedData, sethasAcceptedData] = React.useState<boolean>(
    !!localStorage.getItem(HAS_ACCEPTED_DATA_KEY)
  );
  const [hasEnabledAnalytics, setHasEnabledAnalytics] = React.useState<boolean>(
    localStorage.getItem(FIRST_ANALYTICS_ENABLED_DATE_KEY) != null
  );

  const acceptData = React.useCallback(() => {
    localStorage.setItem(HAS_ACCEPTED_DATA_KEY, "true");
    sethasAcceptedData(true);
  }, []);

  const enableAnalytics = React.useCallback(() => {
    localStorage.setItem(
      FIRST_ANALYTICS_ENABLED_DATE_KEY,
      new Date().toISOString()
    );
    setHasEnabledAnalytics(true);
  }, []);

  const contextValue = React.useMemo(
    () => ({
      hasAcceptedData,
      acceptData,
      hasEnabledAnalytics,
      enableAnalytics,
    }),
    [
      hasAcceptedData,
      acceptData,
      hasEnabledAnalytics,
      enableAnalytics,
    ]
  );

  return (
    <PreferencesContext.Provider value={contextValue}>
      {props.children}
    </PreferencesContext.Provider>
  );
};
